// Open header dropdowns on hover (desktop only) with delay
(function () {
  function initHoverMenus() {
    if (window.innerWidth < 990) return;

    document.querySelectorAll('header .header__inline-menu details').forEach((d) => {
      if (d.__meemHoverBound) return;
      d.__meemHoverBound = true;

      let closeTimeout;

      d.addEventListener('mouseenter', () => {
        clearTimeout(closeTimeout);
        d.setAttribute('open', '');
      });

      d.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(() => {
          d.removeAttribute('open');
        }, 200); // 200ms delay before closing
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initHoverMenus);
  window.addEventListener('resize', initHoverMenus);
})();